import type { Toast } from 'shared/ui/use-toast';
import { useToast } from 'shared/ui/use-toast';
import { useCallback } from 'react';
import * as m from '@paraglide/messages';

export const useApiStatusToast = () => {
  const { toast } = useToast();

  const handleSuccess = useCallback(
    ({ title = m.api_success(), description, ...props }: Toast) => {
      toast({ title, description, variant: 'success', ...props });
    },
    [toast]
  );

  const handleError = useCallback(
    ({
      title = m.api_error_somethingWentWrong(),
      description,
      ...props
    }: Toast) => {
      toast({
        title,
        description,
        variant: 'destructive',
        ...props,
      });
    },
    [toast]
  );

  return [handleSuccess, handleError];
};
